import { LayoutDashboard } from 'lucide-react';

import { defineArea } from '../../app/area';
import { DashboardPage } from './DashboardPage';

/**
 * OWNER: web shell (this area is not a domain module).
 *
 * The landing page of the admin app. Module agents add their own KPI tiles by
 * exporting a widget from their area and… not from here — the dashboard reads
 * `areaModules` itself, so nothing about this file changes when a module ships.
 */
export default defineArea({
  id: 'dashboard',
  nav: [
    {
      section: 'overview',
      to: '/',
      labelKey: 'common:nav.dashboard',
      icon: LayoutDashboard,
      order: 0,
      end: true,
    },
  ],
  routes: [{ index: true, element: <DashboardPage /> }],
});
